import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    comparePhotoPage_title: 'Сравнение фото',
    comparePhotoPage_add: 'Добавить',
    comparePhotoPage_look: 'Просмотр',
    comparePhoto_contingent: 'Контингенты',

    //table
    comparePhoto_columnStatus_NEW: 'Новая',
    comparePhoto_columnStatus_RUNNING: 'В процессе',
    comparePhoto_columnStatus_COMPLETED: 'Готово',
    comparePhoto_columnResult: 'Результат',
    comparePhoto_columnStatus: 'Статус',
    comparePhoto_columnAction: 'Действия',
    comparePhoto_columnServiceProvider: 'Наименование организации',
    comparePhoto_columnFirstContingentId: 'Контингент №1',
    comparePhoto_columnFirstContingentGroupName: 'Наименование группы',
    comparePhoto_columnSecondContingentId: 'Контингент №2',
    comparePhoto_columnSecondContingentGroupName: 'Наименование группы',
    comparePhoto_columnSimilarityPercentage:'Процент схожести',
    comparePhoto_downGrade: 'Переместить на одну позицию ниже',
    comparePhoto_upgrade: 'Переместить на одну позицию выше',
    comparePhoto_delete: 'Удалить',

    //modal
    comparePhoto_modalCreateTitle: 'Создание задания',
    comparePhoto_selectDDO: 'Выберите организацию',
    comparePhoto_addToTop: 'Добавить в начало очереди',
    comparePhoto_add: 'Создать',

    // success
    comparePhoto_successCreateOrder: 'Задача успешно создана',
    comparePhoto_successOrderUp: 'Приоритет задачи успешно повышен',
    comparePhoto_successOrderDown: 'Приоритет задачи успешно понижен',
    comparePhoto_successDeleteOrder: 'Задача успешно удалена',

    //error
    comparePhoto_errorLoadTable: 'Ошибка при загрузке данных',
    comparePhoto_errorOrderUp: 'Ошибка при повышении приоритета задачи',
    comparePhoto_errorOrderDown: 'Ошибка при понижении приоритета задачи',
    comparePhoto_errorDeleteOrder: 'Ошибка при удалении задачи',
    comparePhoto_errorCreateOrder: 'Ошибка при создании задачи',
    comparePhoto_errorGetDDOs: 'Ошибка при загрузке списка организаций',
    comparePhoto_errorLoadMeta: 'Не удалось загрузить метаданные',
    comparePhoto_errorGetResults: 'Не удалось загрузить результаты'
  },
  kk: {
    comparePhotoPage_title: 'Фотосуреттерді салыстыру',
    comparePhoto_columnStatus_NEW: 'Жаңа',
    comparePhoto_columnStatus_RUNNING: 'Өңделуде',
    comparePhoto_columnStatus_COMPLETED: 'Дайын',

    comparePhoto_columnResult: 'Нәтиже',
    comparePhoto_columnStatus: 'Мәртебесі',
    comparePhoto_columnAction: 'Әрекеттер',
    comparePhoto_columnServiceProvider: 'Ұйым атауы',
    comparePhoto_columnFirstContingentId: '№1 контингент',
    comparePhoto_columnFirstContingentGroupName: 'Топ атауы',
    comparePhoto_columnSecondContingentId: '№2 контингент',
    comparePhoto_columnSecondContingentGroupName: 'Топ атауы',
    comparePhoto_columnSimilarityPercentage:'Ұқсастық пайызы',
    comparePhoto_downGrade: 'Бір позицияға төмен жылжыту',
    comparePhoto_upgrade: 'Бір позицияға жоғары жылжыту',
    comparePhoto_delete: 'Жою',

    // modal
    comparePhoto_modalCreateTitle: 'Тапсырма құру',
    comparePhoto_selectDDO: 'Ұйымды таңдаңыз',
    comparePhoto_addToTop: 'Кезектің басына қосу',
    comparePhoto_add: 'Құру',

    // success
    comparePhoto_successCreateOrder: 'Тапсырма сәтті құрылды',
    comparePhoto_successOrderUp: 'Тапсырманың басымдығы сәтті көтерілді',
    comparePhoto_successOrderDown: 'Тапсырманың басымдығы сәтті төмендетілді',
    comparePhoto_successDeleteOrder: 'Тапсырма сәтті жойылды',

    // error
    comparePhoto_errorLoadTable: 'Деректерді жүктеу қатесі',
    comparePhoto_errorOrderUp: 'Тапсырманың басымдығын көтеру қатесі',
    comparePhoto_errorOrderDown: 'Тапсырманың басымдығын төмендету қатесі',
    comparePhoto_errorDeleteOrder: 'Тапсырманы жою қатесі',
    comparePhoto_errorCreateOrder: 'Тапсырманы құру қатесі',
    comparePhoto_errorGetDDOs: 'Ұйымдар тізімін жүктеу қатесі',
    comparePhoto_errorLoadMeta: 'Метадеректерді жүктеу сәтсіз аяқталды',
    comparePhoto_errorGetResults: 'Нәтижелерді жүктеу сәтсіз аяқталды'
  }
});
